import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import PropertyCardShared from './PropertyCardShared';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * SharedCollectionView - Page publique pour visualiser une collection partagée
 */
const SharedCollectionView = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [collectionData, setCollectionData] = useState(null);

  useEffect(() => {
    const loadCollection = async () => {
      try {
        console.log('🔗 Chargement de la collection partagée:', token);
        const response = await axios.get(`${API}/shared-collections/${token}`);
        setCollectionData(response.data);
        setLoading(false);
        console.log('✅ Collection chargée:', response.data.property_count, 'bien(s)');
      } catch (err) {
        console.error('❌ Erreur chargement collection:', err);
        setError(true);
        setLoading(false);
      }
    };

    if (token) {
      loadCollection();
    }
  }, [token]);

  // État de chargement
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl text-blue-600 mb-4 animate-spin">
            <i className="bi bi-hourglass-split"></i>
          </div>
          <p className="text-gray-600 text-lg">Chargement de la collection...</p>
        </div>
      </div>
    );
  }

  // Erreur
  if (error || !collectionData) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
          <div className="text-6xl text-red-500 mb-4">
            <i className="bi bi-exclamation-triangle"></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Collection introuvable</h2>
          <p className="text-gray-600">
            Ce lien de partage n'existe pas ou a expiré.
          </p>
        </div>
      </div>
    );
  }

  // Affichage de la collection
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Header */}
      <div className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
              <i className="bi bi-collection text-blue-600"></i>
              {collectionData.title}
            </h1>
            <div className="text-sm text-gray-600">
              <i className="bi bi-eye mr-2"></i>
              {collectionData.view_count} vue(s)
            </div>
          </div>
          {collectionData.description && (
            <p className="text-gray-600 mt-2">{collectionData.description}</p>
          )}
        </div>
      </div>

      {/* Liste des biens */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {collectionData.properties && collectionData.properties.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {collectionData.properties.map((property) => (
              <PropertyCardShared 
                key={property.id}
                property={property}
                token={token}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <div className="text-4xl text-gray-400 mb-4">
              <i className="bi bi-inbox"></i>
            </div>
            <p className="text-gray-600 text-lg">Cette collection ne contient aucun bien pour le moment.</p>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="bg-white border-t border-gray-200 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center text-gray-600 text-sm">
          <p>Cette collection contient {collectionData.property_count} bien(s)</p>
        </div>
      </div>
    </div>
  );
};

export default SharedCollectionView;
